/*@flow*/
/** @jsx jsx */
import { jsx } from '@emotion/core';
import VegaLite, { type Props, type Spec } from 'comps/App/VegaLite';
import { useEffect, useState, createRef } from 'react';

const useContainerDim = () => {
  const [dim, setDim] = useState({ width: 0, height: 0 });
  const ref = createRef();
  useEffect(() => {
    if (!ref.current) return;
    const width = ref.current.offsetWidth;
    const height = ref.current.offsetHeight;
    if (width !== dim.width || height !== dim.height) {
      setDim({ width, height });
    }
  }, []);
  return [ref, dim];
};

type Dim = { width: number, height: number };

export default ({
  provideSpec,
  css,
  ...props
}: Props<> & { css?: Object, provideSpec?: Dim => Spec }) => {
  const [ref, dim] = useContainerDim();
  let spec = props.spec;
  if (typeof provideSpec === 'function') {
    spec = provideSpec(dim);
  }

  return (
    <div style={{ height: '100%', width: '100%' }} css={css} ref={ref}>
      {dim.width > 0 && (
        <VegaLite
          onParseError={console.error}
          {...props}
          spec={{ ...spec, ...dim }}
        />
      )}
    </div>
  );
};
